<template>
  <div>Authentication...</div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import { useAuthStore } from '@/stores/auth-store'
import { useRouter } from 'vue-router'

export default defineComponent({
  setup() {
    const authStore = useAuthStore()
    const { push } = useRouter()

    onMounted(async () => {
      await authStore
        .handleRedirectCallback()
        .then(() => {
          const returnUrl = authStore.returnUrl ? authStore.returnUrl : '/'
          push(returnUrl)
        })
        .catch((error) => {
          console.error('Error handling sign-in callback:', error)
        })
    })
  },
})
</script>
